<script setup lang="ts">
import BaseButton from "@/core/components/base/BaseButton.vue";
import {
    Dialog,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTitle,
    DialogTrigger
} from "@/core/components/ui/dialog";
import {AutoCompleteSearchbar} from "@/auto-complete-searchbar/components/searchbar";
import {ref, watch} from "vue";
import {
    SearchBarAutoCompleteItem
} from "@/auto-complete-searchbar/interfaces/ISearchBarAutoComplete";
import AutoCompleteSearchBarProductDatatable
    from "@/auto-complete-searchbar/components/searchbar/AutoCompleteSearchBarProductDatatable.vue";
import LaboratoryProduct from "@/core/interfaces/laboratory/LaboratoryProduct";

const emits = defineEmits<{
    (e: 'confirm', payload: number[]): void;
}>();

const items = ref<SearchBarAutoCompleteItem[]>([]);
const productIds = ref<number[]>([]);
const loadingProducts = ref(false);
const open = ref(false);
const tableProduct = ref<LaboratoryProduct[]>([]);

watch(open, (value) => {
    if (value) {
        items.value = [];
        productIds.value = [];
    }
});

/**
 * Confirm product selection.
 */
const confirm = () => {
    emits("confirm", productIds.value);
    open.value = false;
};
</script>

<template>
  <Dialog v-model:open="open">
    <DialogTrigger as-child>
      <BaseButton primary density="comfortable">
        Ajouter un produit
      </BaseButton>
    </DialogTrigger>
    <DialogContent class="flex flex-col max-h-[80dvh]" @interact-outside="(e) => e.preventDefault()">
      <DialogHeader class="p-0">
        <DialogTitle>
          Ajouter un produit
        </DialogTitle>
      </DialogHeader>
      <div class="space-y-4">
        <AutoCompleteSearchbar
          v-model:selected-items="items"
        />
        <AutoCompleteSearchBarProductDatatable
          v-model:selected="productIds"
          :items="items"
          @product-loaded="products => tableProduct = products"
        />
      </div>
      <DialogFooter>
        <BaseButton
          density="comfortable"
          primary
          :loading="loadingProducts"
          :disabled="!productIds?.length"
          @click="confirm"
        >
          Valider la sélection de {{ productIds?.length }} produit{{ productIds?.length > 1 ? 's' : '' }}
        </BaseButton>
      </DialogFooter>
    </DialogContent>
  </Dialog>
</template>
